var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70687 10.0031C7.70687 9.00212 6.89542 8.19067 5.89445 8.19067C4.89348 8.19067 4.08203 9.00212 4.08203 10.0031L4.08203 28.1281C4.08203 28.1282 4.08203 28.1284 4.08203 28.1285L4.08203 37.1894C4.08203 38.1903 4.89348 39.0018 5.89445 39.0018L38.518 39.0018C39.5189 39.0018 40.3304 38.1903 40.3304 37.1894C40.3304 36.1884 39.5189 35.3769 38.518 35.3769L7.70687 35.3769L7.70687 28.9762L16.6578 21.5171L22.7371 27.5965C23.4118 28.2712 24.4941 28.3072 25.2122 27.6789L39.7115 14.992C40.4648 14.3328 40.5411 13.1878 39.882 12.4345C39.2228 11.6812 38.0778 11.6048 37.3245 12.264L24.1013 23.8343L18.0506 17.7837C17.3877 17.1208 16.3288 17.0728 15.6087 17.6729L7.70687 24.2578L7.70687 10.0031Z",
    fill: "#85C3F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.ed531223fc8c69afc4a06755d6732a30.svg";
export { ForwardRef as ReactComponent };